import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../img/search.png';
import _imports_1 from '../../img/icons/Frame_1000008062@2x.png';
import _imports_2 from '../../img/icons/Frame_1000008063@2x.png';
import _imports_3 from '../../img/icons/Frame_1000008064@2x.png';
import _imports_4 from '../../img/icons/Frame_1000008065@2x.png';
const _withScopeId = n => (_pushScopeId("data-v-29ecfd5c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "carouselImg"
};
const _hoisted_3 = ["src", "onClick"];
const _hoisted_4 = {
  class: "inputBox"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_7 = {
  class: "process"
};
const _hoisted_8 = {
  key: 0,
  class: "name"
};
const _hoisted_9 = {
  key: 1,
  class: "name"
};
const _hoisted_10 = {
  class: "processList"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 0,
  class: "names"
};
const _hoisted_13 = {
  key: 1,
  class: "names"
};
const _hoisted_14 = {
  key: 2,
  class: "description"
};
const _hoisted_15 = {
  key: 3,
  class: "description"
};
const _hoisted_16 = {
  key: 4,
  src: _imports_1,
  alt: ""
};
const _hoisted_17 = {
  key: 5,
  src: _imports_2,
  alt: ""
};
const _hoisted_18 = {
  key: 6,
  src: _imports_3,
  alt: ""
};
const _hoisted_19 = {
  key: 7,
  src: _imports_4,
  alt: ""
};
const _hoisted_20 = {
  class: "testkit"
};
const _hoisted_21 = {
  key: 0,
  class: "name"
};
const _hoisted_22 = {
  key: 1,
  class: "name"
};
const _hoisted_23 = {
  class: "testkitList"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "names"
};
const _hoisted_26 = {
  class: "description"
};
const _hoisted_27 = {
  class: "box"
};
const _hoisted_28 = {
  class: "CASBox"
};
const _hoisted_29 = {
  key: 0,
  class: "title"
};
const _hoisted_30 = {
  key: 1,
  class: "title"
};
const _hoisted_31 = {
  class: "values",
  style: {
    "width": "110px"
  }
};
const _hoisted_32 = {
  class: "CASBox"
};
const _hoisted_33 = {
  key: 0,
  class: "title"
};
const _hoisted_34 = {
  key: 1,
  class: "title"
};
const _hoisted_35 = {
  class: "values",
  style: {
    "width": "80px"
  }
};
const _hoisted_36 = {
  class: "CASBox"
};
const _hoisted_37 = {
  key: 0,
  class: "title"
};
const _hoisted_38 = {
  key: 1,
  class: "title"
};
const _hoisted_39 = {
  class: "values"
};
const _hoisted_40 = {
  class: "CASBox"
};
const _hoisted_41 = {
  key: 0,
  class: "title"
};
const _hoisted_42 = {
  key: 1,
  class: "title"
};
const _hoisted_43 = {
  class: "values"
};
const _hoisted_44 = {
  class: "priceBox"
};
const _hoisted_45 = {
  class: "price"
};
const _hoisted_46 = {
  class: "gram"
};
const _hoisted_47 = ["src"];
const _hoisted_48 = {
  class: "popular"
};
const _hoisted_49 = {
  key: 0,
  class: "name"
};
const _hoisted_50 = {
  key: 1,
  class: "name"
};
const _hoisted_51 = ["src", "onClick"];
const _hoisted_52 = {
  class: "popularList"
};
const _hoisted_53 = ["onClick"];
const _hoisted_54 = ["src"];
const _hoisted_55 = {
  class: "names"
};
const _hoisted_56 = {
  class: "description"
};
const _hoisted_57 = {
  class: "box"
};
const _hoisted_58 = {
  class: "CASBox"
};
const _hoisted_59 = {
  key: 0,
  class: "title"
};
const _hoisted_60 = {
  key: 1,
  class: "title"
};
const _hoisted_61 = {
  class: "values",
  style: {
    "width": "110px"
  }
};
const _hoisted_62 = {
  class: "CASBox"
};
const _hoisted_63 = {
  key: 0,
  class: "title"
};
const _hoisted_64 = {
  key: 1,
  class: "title"
};
const _hoisted_65 = {
  class: "values",
  style: {
    "width": "80px"
  }
};
const _hoisted_66 = {
  class: "CASBox"
};
const _hoisted_67 = {
  key: 0,
  class: "title"
};
const _hoisted_68 = {
  key: 1,
  class: "title"
};
const _hoisted_69 = {
  class: "values"
};
const _hoisted_70 = {
  class: "CASBox"
};
const _hoisted_71 = {
  key: 0,
  class: "title"
};
const _hoisted_72 = {
  key: 1,
  class: "title"
};
const _hoisted_73 = {
  class: "values"
};
const _hoisted_74 = {
  class: "priceBox"
};
const _hoisted_75 = {
  class: "price"
};
const _hoisted_76 = {
  class: "gram"
};
const _hoisted_77 = {
  class: "newproduct"
};
const _hoisted_78 = {
  key: 0,
  class: "name"
};
const _hoisted_79 = {
  key: 1,
  class: "name"
};
const _hoisted_80 = {
  class: "popularList"
};
const _hoisted_81 = ["onClick"];
const _hoisted_82 = ["src"];
const _hoisted_83 = {
  class: "names"
};
const _hoisted_84 = {
  class: "description"
};
const _hoisted_85 = {
  class: "box"
};
const _hoisted_86 = {
  class: "CASBox"
};
const _hoisted_87 = {
  key: 0,
  class: "title"
};
const _hoisted_88 = {
  key: 1,
  class: "title"
};
const _hoisted_89 = {
  class: "values",
  style: {
    "width": "110px"
  }
};
const _hoisted_90 = {
  class: "CASBox"
};
const _hoisted_91 = {
  key: 0,
  class: "title"
};
const _hoisted_92 = {
  key: 1,
  class: "title"
};
const _hoisted_93 = {
  class: "values",
  style: {
    "width": "80px"
  }
};
const _hoisted_94 = {
  class: "CASBox"
};
const _hoisted_95 = {
  key: 0,
  class: "title"
};
const _hoisted_96 = {
  key: 1,
  class: "title"
};
const _hoisted_97 = {
  class: "values"
};
const _hoisted_98 = {
  class: "CASBox"
};
const _hoisted_99 = {
  key: 0,
  class: "title"
};
const _hoisted_100 = {
  key: 1,
  class: "title"
};
const _hoisted_101 = {
  class: "values"
};
const _hoisted_102 = {
  class: "priceBox"
};
const _hoisted_103 = {
  class: "price"
};
const _hoisted_104 = {
  class: "gram"
};
import { reactive, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getColumnListConfig, publicListConfig } from "../../api/home";
import { useStore } from 'vuex';
import { ref } from "vue";
export default {
  __name: 'Home',
  setup(__props) {
    const one = ref(true); //当one为true时执行轮播。以此来控制每次轮播图切换的张数为1
    const swiper = ref(null);
    const data = reactive({
      input: "",
      bannerLists: [],
      bannerListsOne: [],
      processDate: [{
        name: "定制合成",
        englishName: "Custom Synthesis",
        description: "专业团队 快速响应",
        descriptionEnglish: "Professional Team, Rapid Response"
      }, {
        name: "公斤级采购",
        englishName: "Kilogram-Level Procurement",
        description: "批量现货 价格从优",
        descriptionEnglish: "Bulk In Stock,  Price  At  A  Favorable Rate"
      }, {
        name: "检测报告",
        englishName: "Inspection Report",
        description: "资质齐全 质量保证",
        descriptionEnglish: "Complete Qualifications, Quality Assurance"
      }, {
        name: "售后服务",
        englishName: "After-Sales Service",
        description: "专业指导 贴心服务",
        descriptionEnglish: "Professional Guidance, Attentive Service"
      }],
      testkitDate: [],
      popularDate: [],
      bannerType: 1,
      bannerTypeOne: 2,
      selectChannel: 1,
      popularDateOne: []
    });
    const route = useRoute();
    const router = useRouter();
    const carouselRef = ref(null);
    const carouselRefOne = ref(null);
    const store = useStore();
    const switchShow = computed(() => store.state.switchShow);
    const treeSelect = () => {
      publicListConfig().then(res => {
        if (res?.resultCode == 200) {
          if (res.data) {
            let found = res.data.find(element => element.areaType === 1);
            let found1 = res.data.find(element => element.areaType === 2);
            let found2 = res.data.find(element => element.areaType === 3);
            console.log(found, found1, found2, "asjas");
            data.testkitDate = found?.productVoList;
            data.popularDate = found1?.productVoList;
            data.popularDateOne = found2?.productVoList;
          } else {
            data.testkitDate = [];
            data.popularDate = [];
            data.popularDateOne = [];
          }
        }
        console.log(res, "saas");
      });
    };
    const bannerList = () => {
      getColumnListConfig(data.bannerType, data.selectChannel).then(res => {
        if (res?.resultCode == 200) {
          data.bannerLists = res.data;
        }
        console.log(res, "saas");
      });
    };
    const imgLoad = e => {
      const img = e.target;
      // 获取图片真实高度
      const realHeight = img.offsetHeight;
      // 动态修改轮播容器高度
      carouselRef.value.$el.style.height = realHeight + 'px';
    };

    // 监听轮播切换，重新自适应高度
    const change = () => {
      // setTimeout(() => {
      //   const img = carouselRef.value.$el.querySelector('img')
      //   console.log(img,img.offsetHeight,"huoqugaodu");
      //   carouselRef.value.$el.style.height = img.offsetHeight + 'px'
      // }, 50)
    };
    const imgLoadOne = e => {
      const img = e.target;
      // 获取图片真实高度
      const realHeight = img.offsetHeight;
      console.log("as", e.target, realHeight);
      // 动态修改轮播容器高度
      carouselRefOne.value.$el.style.height = realHeight + 'px';
    };

    // 监听轮播切换，重新自适应高度
    const changeOne = () => {
      // setTimeout(() => {
      //   const img = carouselRefOne.value.$el.querySelector('img');
      //   console.log(img, img.offsetHeight, "huoqugaodu");
      //   carouselRefOne.value.$el.style.height = img.offsetHeight + 'px'
      // }, 50)
    };
    const bannerListOne = () => {
      getColumnListConfig(data.bannerTypeOne, data.selectChannel).then(res => {
        if (res?.resultCode == 200) {
          data.bannerListsOne = res.data;
        }
        console.log(res, "saas");
      });
    };
    const searchBtn = id => {
      // treeSelect()
      router.push({
        path: "/search",
        query: {
          keyword: data.input,
          type: id
        }
      });
    };
    const testkitBtn = userId => {
      router.push({
        path: "/commodity",
        query: {
          userId: userId
        }
      });
    };
    const processBtn = val => {
      console.log(val, "saasjasj");
      if (val <= 1) {
        localStorage.setItem("headId", "2");
        router.push({
          path: "/service"
        });
      } else {
        localStorage.setItem("headId", "5");
        router.push({
          path: "/medium"
        });
      }
    };
    const carouselBtn = val => {
      if (val.redirectType == 1) {
        router.push({
          path: "/commodity",
          query: {
            userId: val.redirectGoal
          }
        });
      }
    };
    onMounted(() => {
      // 代码逻辑0
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动（去掉就是瞬间回到顶部）
      });

      bannerList();
      treeSelect();
      bannerListOne();
    });
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_carousel, {
        height: "auto",
        "motion-blur": "",
        ref_key: "carouselRef",
        ref: carouselRef,
        "indicator-position": "outside",
        onChange: change
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.bannerLists, item => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: item.id
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              src: item.image,
              onLoad: imgLoad,
              alt: "",
              onClick: $event => carouselBtn(item)
            }, null, 40, _hoisted_3)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 512)]), _createElementVNode("div", _hoisted_4, [switchShow.value == true ? (_openBlock(), _createBlock(_component_el_input, {
        key: 0,
        modelValue: data.input,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.input = $event),
        placeholder: "请输入试剂名称、CAS号、结构式等",
        class: "input-with-select"
      }, {
        prepend: _withCtx(() => [_hoisted_5]),
        append: _withCtx(() => [switchShow.value == true ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "btn",
          onClick: _cache[0] || (_cache[0] = $event => searchBtn(0))
        }, "搜索")) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createBlock(_component_el_input, {
        key: 1,
        modelValue: data.input,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.input = $event),
        placeholder: "Please enter the reagent name, CAS number, structural formula, etc",
        class: "input-with-select"
      }, {
        prepend: _withCtx(() => [_hoisted_6]),
        append: _withCtx(() => [switchShow.value == false ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "btn",
          onClick: _cache[2] || (_cache[2] = $event => searchBtn(0))
        }, "search")) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), switchShow.value == true ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "btns",
        onClick: _cache[4] || (_cache[4] = $event => searchBtn(1))
      }, "结构式搜索")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_8, "服务")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_9, "service")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.processDate, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "processListBOx",
          key: index,
          onClick: $event => processBtn(index)
        }, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.name), 1)) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(item.englishName), 1)) : _createCommentVNode("", true), switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item.description), 1)) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(item.descriptionEnglish), 1)) : _createCommentVNode("", true), index == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_16)) : _createCommentVNode("", true), index == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_17)) : _createCommentVNode("", true), index == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_18)) : _createCommentVNode("", true), index == 3 ? (_openBlock(), _createElementBlock("img", _hoisted_19)) : _createCommentVNode("", true)], 8, _hoisted_11);
      }), 128))])]), _createElementVNode("div", _hoisted_20, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_21, "试剂盒展示区")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Reagent Kit Display Area")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.testkitDate, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "testkitListBOx",
          key: index,
          onClick: $event => testkitBtn(item.id)
        }, [_createElementVNode("div", _hoisted_25, _toDisplayString(item.productName), 1), _createElementVNode("div", _hoisted_26, _toDisplayString(item.productEnglishName), 1), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_29, "CAS:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_30, "CAS：")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_31, _toDisplayString(item.casNo), 1)]), _createElementVNode("div", _hoisted_32, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_33, "分子式:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Formula:")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_35, _toDisplayString(item.molecule), 1)]), _createElementVNode("div", _hoisted_36, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_37, "相对分子质量:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Mol. Wt:")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_39, _toDisplayString(item.molecularMass), 1)]), _createElementVNode("div", _hoisted_40, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_41, "纯度:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Purity：")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_43, _toDisplayString(item.purity), 1)])]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, "¥" + _toDisplayString(item.minPrice), 1), _createElementVNode("div", _hoisted_46, "/" + _toDisplayString(item.minPackaging), 1)]), _createElementVNode("img", {
          src: item.baseImage,
          alt: ""
        }, null, 8, _hoisted_47)], 8, _hoisted_24);
      }), 128))])]), _createElementVNode("div", _hoisted_48, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_49, "热门试剂推荐")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Recommended Popular Reagents")) : _createCommentVNode("", true), _createVNode(_component_el_carousel, {
        height: "auto",
        "motion-blur": "",
        ref_key: "carouselRefOne",
        ref: carouselRefOne,
        "indicator-position": "outside",
        onChange: changeOne
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.bannerListsOne, item => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: item.id
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              src: item.image,
              alt: "",
              onLoad: imgLoadOne,
              onClick: $event => carouselBtn(item)
            }, null, 40, _hoisted_51)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 512), _createElementVNode("div", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.popularDate, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "popularListBOx",
          key: index,
          onClick: $event => testkitBtn(item.id)
        }, [_createElementVNode("img", {
          src: item.baseImage,
          alt: ""
        }, null, 8, _hoisted_54), _createElementVNode("div", _hoisted_55, _toDisplayString(item.productName), 1), _createElementVNode("div", _hoisted_56, _toDisplayString(item.productEnglishName), 1), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_59, "CAS:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_60, "CAS：")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_61, _toDisplayString(item.casNo), 1)]), _createElementVNode("div", _hoisted_62, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_63, "分子式:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_64, "Formula:")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_65, _toDisplayString(item.molecule), 1)]), _createElementVNode("div", _hoisted_66, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_67, "相对分子质量:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_68, "Mol. Wt:")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_69, _toDisplayString(item.molecularMass), 1)]), _createElementVNode("div", _hoisted_70, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_71, "纯度:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_72, "Purity：")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_73, _toDisplayString(item.purity), 1)])]), _createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, "¥" + _toDisplayString(item.minPrice), 1), _createElementVNode("div", _hoisted_76, "/" + _toDisplayString(item.minPackaging), 1)])], 8, _hoisted_53);
      }), 128))])]), _createElementVNode("div", _hoisted_77, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_78, "新品试剂推荐")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_79, "Recommendations For New Reagents")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_80, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.popularDateOne, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "popularListBOx",
          key: index,
          onClick: $event => testkitBtn(item.id)
        }, [_createElementVNode("img", {
          src: item.baseImage,
          alt: ""
        }, null, 8, _hoisted_82), _createElementVNode("div", _hoisted_83, _toDisplayString(item.productName), 1), _createElementVNode("div", _hoisted_84, _toDisplayString(item.productEnglishName), 1), _createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_87, "CAS:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_88, "CAS：")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_89, _toDisplayString(item.casNo), 1)]), _createElementVNode("div", _hoisted_90, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_91, "分子式:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_92, "Formula:")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_93, _toDisplayString(item.molecule), 1)]), _createElementVNode("div", _hoisted_94, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_95, "相对分子质量:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_96, "Mol. Wt:")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_97, _toDisplayString(item.molecularMass), 1)]), _createElementVNode("div", _hoisted_98, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_99, "纯度:")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_100, "Purity：")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_101, _toDisplayString(item.purity), 1)])]), _createElementVNode("div", _hoisted_102, [_createElementVNode("div", _hoisted_103, "¥" + _toDisplayString(item.minPrice), 1), _createElementVNode("div", _hoisted_104, "/" + _toDisplayString(item.minPackaging), 1)])], 8, _hoisted_81);
      }), 128))])])]);
    };
  }
};